// ~/config/app.config.ts
// Single source of truth for the EquiRize Investor mobile app store listings.
// Consumed by components/footer/appLinks.vue and the homepage JSON-LD in pages/index.vue.

export const IOS_APP_ID = "6790696147"
export const ANDROID_PACKAGE_NAME = "com.equirize.equirize_investor"

export const APP_STORE_URL = `https://apps.apple.com/in/app/equirize-investor/id${IOS_APP_ID}`
export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE_NAME}`

export const APP_NAME = "EquiRize Investor"

/** Both store URLs, for schema.org `sameAs` and anywhere else both are needed. */
export const APP_STORE_URLS = [APP_STORE_URL, PLAY_STORE_URL]
